import {Component, OnInit } from '@angular/core';
import { AppUtilService } from 'app/services/app-util.service';

@Component({
  selector: 'not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['../app.scss','./not-authorized.component.scss']
})
export class NotAuthorizedComponent implements OnInit {
  constructor(
    private appUtil: AppUtilService
  ) {}

  public ngOnInit(): void {
    this.appUtil.setTitle('Application Access');
  }

}
